import axios from 'axios';

const ICONS = {
  overview: 'chart-line',
  scorecard: 'user-check',
  attribution: 'users',
  coding: 'file-medical',
  quality: 'clipboard-list-check',
  utilization: 'hospital',
  explorer: 'magnifying-glass',
  patients: 'user',
};

export async function fetchPortalTabs() {
  const { data } = await axios.get('/api/impact_analytics/agent-pages/external/');
  return data.tabs || [];
}

export const PATIENTS_TAB = 'patients';

export function portalNavItems(tabs) {
  return [
    ...tabs.filter((tab) => tab.key !== PATIENTS_TAB).map((tab) => ({ id: tab.key, label: tab.label, icon: ICONS[tab.key] || 'file-lines' })),
    { id: PATIENTS_TAB, label: 'Patients', icon: ICONS[PATIENTS_TAB] },
  ];
}
